<bento-alert [items]="alerts">
</bento-alert>

<ng-template #actionsColumnCell let-item>
	<i *ngIf="!(item.migrationId === migrationDetailsItemId && showDownloadReportBusyLoader)"
			class="bento-icon-exit cursor-pointer ml-2"
	   role="button"
	   [aria-label]="'onvio.setup.migrations.exportMigrationResultsButtonAltText' | translate"
	   [ngbTooltip]="'onvio.setup.migrations.exportMigrationResultsButtonAltText' | translate"
	   data-qe-id="migration-dashboard-migration-details-export"
	   (click)="downloadMigrationDetailsReport(item)"></i>
	<span *ngIf="item.migrationId === migrationDetailsItemId && showDownloadReportBusyLoader"
		  [bentoBusyLoader]="true"
		  [size]="'sm'"></span>
</ng-template>

<ng-template #applicationColumnCell let-item>
	<span *ngIf="migrationSource === TAX_COMPETITOR_MIGRATION_SOURCE; else applicationLink">
				{{item.metadata.competitorDescription}}
			</span>
	<ng-template #applicationLink>
		<button class="btn btn-link btn-lg goto-product"
				data-qe-id="migration-dashboard-completed-application-link"
				type="button" (click)="gotoProduct.emit(item)">
					<span *ngIf="item.migrationSource !== TAX_COMPETITOR_MIGRATION_SOURCE; else thirdPartyName">
						{{item.migrationSource | applicationName}}
					</span>
			<ng-template #thirdPartyName>
						<span>
						{{item.metadata.competitorDescription}}
						</span>
			</ng-template>
		</button>
	</ng-template>
</ng-template>

<ng-template #startedOnColumnCell let-item>
	{{item.migrationStartDate | formatDateTime }}
</ng-template>

<ng-template #statusColumnCell let-item>
	Completed on {{item.migrationChangeDate | formatDateTime}}
</ng-template>

<ng-template #recordsMigratedColumnCell let-item>
	<button type="button" class="migration-details btn btn-link" [disabled]="item.recordsMigrated === 0"
			attr.data-qe-id="migration-dashboard-{{ migrationSource.toLowerCase() }}-records-migrated-link"
			[ngClass]="{'wait-for-response': showDetailsBusyLoader === true}"
			*ngIf="!(item.migrationId === migrationDetailsItemId && showDetailsBusyLoader)"
			(click)="showMigratedRecordDetailsInfo(item, completedMigrationContainer)">
		{{item.recordsMigrated}}
	</button>
	<span *ngIf="item.migrationId === migrationDetailsItemId && showDetailsBusyLoader"
		  [bentoBusyLoader]="true"
		  [size]="'sm'"></span>
</ng-template>

<ng-template #exclusionsColumnCell let-item>
	<button type="button" class="migration-alerts btn btn-link" [disabled]="item.alertCount === 0"
			attr.data-qe-id="migration-dashboard-{{ migrationSource.toLowerCase() }}-exclusions-link"
			[ngClass]="{'wait-for-response': showDetailsBusyLoader === true}"
			*ngIf="!(item.migrationId === migrationDetailsItemId && showAlertsBusyLoader)"
			(click)="showMigratedRecordAlertsInfo(item, completedMigrationContainer)">
		{{item.alertCount}}
	</button>
	<span *ngIf="item.migrationId === migrationDetailsItemId && showAlertsBusyLoader"
		  [bentoBusyLoader]="true"
		  [size]="'sm'"></span>
</ng-template>

<ng-template #onlyCompletedTable>
	<app-table *ngIf="migrationResults"
			   [tableModel]="tableModel">
	</app-table>
</ng-template>

<bento-alert [inline]="true" [items]="migrationErrorAlerts"></bento-alert>

<div class="completed-migration-results ng-bento" #completedMigrationContainer [bentoBusyLoader]="showBusyloader">
  <ng-container *ngIf="!showOnlyTable">
    <h2>
      {{'onvio.setup.migrations.status.completed' | translate}}
      <span class="badge badge-info completed-badge-count" *ngIf="migrationResults && migrationResults.length > 0">
        {{migrationResults.length}}
      </span>
    </h2>
		<a href="#/setup/migrations/client-registration" *ngIf="showClientRegistrationLink" class="client-registration-link">
			{{'onvio.setup.migrations.status.completed.ClientCenterRegistrations' | translate}}
		</a>
		<div class="template">
			<ng-container *ngTemplateOutlet="customTemplate ? customTemplate: defaultTemplate"></ng-container>
			<ng-container *ngTemplateOutlet="onlyCompletedTable"></ng-container>
		</div>
  </ng-container>

  <ng-container *ngIf="showOnlyTable">
		<ng-container *ngTemplateOutlet="onlyCompletedTable"></ng-container>
  </ng-container>
</div>

<ng-template #defaultTemplate>
  <p *ngIf="!migrationResults || !migrationResults.length">
    <strong>{{'onvio.setup.migrations.nothing.completed' | translate}}</strong>
  </p>
</ng-template>
